// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"194":"error","952":"promotion"}[chunkId] + "." + {"194":"1abbc681","952":"0e022602"}[chunkId] + ".css";
};